import apiClient  from './Client';


class CartService {
    async CreateCart(productId: number, postData: any) {
        console.log(productId);
        console.log(postData);
        try {
        const response = await apiClient.post(`/Cart/add-to-cart/${productId}`, postData);
        console.log(response);
        return response.data;

        } catch (err:any) {
          console.log(err);
          if(err.response?.status===400 && err.response?.data?.message==="Error in adding product to cart") {
            return "Failed to cart the product";
          }
          return "Failed to cart the product";
        }
    };

    async UpdateCart(productId: number, cartID: number, postData: any) { 
      try {
      const response = await apiClient.put(`/Cart/update-cart/${productId}`, postData); 
      console.log(response);
      return response.data;
        
      } catch (err:any) {
        if(err.response.status===400)
        {
          console.log(err); 
          if(err.response.data.message==="Error in updating cart")
            return "Failed to update cart";
        }
          
      }
  };

  async GetCart(){
    try {
      const response = await apiClient.get(`/Cart/get-cart-items`);
      console.log(response);
      return response.data;
    } catch (error) {
        console.error("Failed to fetch cart items", error);
        throw error;  
    }
  }

  async DeleteCartProject(cartId: number){    
    try {
      const response = await apiClient.delete(`/Cart/${cartId}`);
      return response;
    } catch (error) {
      
    }
  }

  async GetCartCount(){
    try {
      const response = await apiClient.get(`/Cart/cart-count`);
      console.log(response);
      return response.data;
    } catch (error) {
        console.error("Failed to fetch cart items", error);
        throw error;  
    }
  }
}
export default new CartService()